import PropTypes from "prop-types";
import React from "react";

const NoVisit = ({showDesc, title}) => {
  return (
    <span className="NoVisit">
      <span
        className="erg-margin-right-5 text-danger"
        title={!showDesc ? title : ""}>
        <i className="fa fa-minus-circle" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

NoVisit.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

NoVisit.defaultProps = {
  title: "No Visit Template",
};

export default NoVisit;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/NoVisit.js
 **/